const $ = window.jQuery;

var MAX_WAIT_TIME = 10000;
var $window = $(window);

$.fn.visible = function () {
  var viewportTop = $window.scrollTop();
  var viewportBottom = viewportTop + $window.height();
  var compareTop = $(this).offset().top;
  return viewportBottom >= compareTop;
};

setTimeout(function () {
  checkVisible();
}, MAX_WAIT_TIME);

setInterval(function () {
  checkVisible();
}, 10);

function checkVisible() {
  $('.check-visible').each(function (index, element) {
    var $element = $(element);
    if ($element.visible())
      $element.addClass('visible');
  });
}

export default checkVisible;
